import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from 'src/app/shared/services/http/auth/auth.service';


@Component({
  selector: 'app-payment-success-bulk-popup',
  templateUrl: './payment-success-bulk-popup.component.html',
  styleUrls: ['./payment-success-bulk-popup.component.scss']
})
export class PaymentSuccessBulkPopupComponent {

  constructor(public dialogRef: MatDialogRef<PaymentSuccessBulkPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AuthService) {
    console.log('data', data);

  }
  ngOnInit() {

  }
  schoolId: any;


  closeModal() {
    this.dialogRef.close({
      match: true,
    })
  }

 
}
